// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"tk_a big_a big_r big_j","Photos__img":"tk_b big_b"};